import { CSSProperties } from "react";

import { successBackground } from "@assets";
import { constants, palette } from "@layout";
import styled from "styled-components";

export const Container = styled.div`
  height: 550px;
  width: 350px;

  @media (max-width: 600px) {
    height: 400px;
    width: 250px;
  }
`;

export const styles: Record<string, CSSProperties> = {
  container: {
    backgroundImage: `url(${successBackground})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",

    padding: constants.divPadding,
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-end",
    borderRadius: constants.radius.card,
  },
  icon: {
    fontSize: 80,
  },
  title: {
    color: palette.white[100],
  },
  subtitle: {
    color: palette.white[60],
  },
  button: {
    padding: 12,
    backgroundColor: palette.white[100],
  },
  buttonText: {
    color: palette.black[100],
  },
};
